<ng-container *transloco="let t">
  <app-close-relative-form [submitButtonText]="t('closeRelative/add')" (formSubmit)="createCloseRelative($event)"></app-close-relative-form>
</ng-container>
